import { inject } from '@angular/core';
import { AppConfigService } from '@data-terminal/data-access/app-config/app-config.service';
import { APP_NAME, BACKEND_URL, TASKPILOT_BACKEND_URL, WINDOW } from '@data-terminal/data-access/injection-tokens';
import { ConfigService } from '@heidelberg/control-center-frontend-integration';
import { CCAppAuthConfig } from '@heidelberg/control-center-frontend-integration/auth';

const TRAILING_SLASH_PATTERN = /\/+$/;

export function createAuthConfig(service: AppConfigService, configService: ConfigService): CCAppAuthConfig {
    const taskPilotBackendUrl = inject(TASKPILOT_BACKEND_URL).replace(TRAILING_SLASH_PATTERN, '');

    return {
        ccStage: service.getCCStage(),
        clientId: service.getOAuthClientId(),
        appId: inject(APP_NAME),
        requiresOrganizationContext: true,
        authenticatedUrls: [
            '/api',
            inject(BACKEND_URL),
            inject(WINDOW).location.origin + '/',
            configService.getNotificationSvcUrl(),
            taskPilotBackendUrl,
        ],
    };
}
